import {DialogBackdrop} from '@headlessui/react'
import {motion} from 'framer-motion'

import {FadeInOutAnimation} from '../../../animations'

import type {MotionProps} from 'framer-motion'
import type {DialogBackdropProps} from '@headlessui/react'

const MotionDialogBackdrop = motion(DialogBackdrop)

export const Backdrop = (props: MotionProps & DialogBackdropProps) => (
  <MotionDialogBackdrop
    className={'absolute inset-0 z-10 bg-scrim-primary/45'}
    {...FadeInOutAnimation}
    {...props}
  />
)